module.exports = __webpack_public_path__ + "img/comparison-category-category.834aeeac.png";